const params = new URL(location.href).searchParams;

const source = params.get("utm_source");
const medium = params.get("utm_medium");
const campaign = params.get("utm_campaign");
const content = params.get("utm_content");
const term = params.get("utm_term");

const setCookie = (name, value, days) => {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

if (source) {
	setCookie("utm_source", source, 30);
}

if (medium) {
	setCookie("utm_medium", medium, 30);
}

if (campaign) {
	setCookie("utm_campaign", campaign, 30);
}

if (content) {
	setCookie("utm_content", content, 30);
}

if (term) {
	setCookie("utm_term", term, 30);
}
